import React, { useContext } from "react";
import { ShopContext } from "../../context/ShopContext";

const SUBCATEGORY_LABELS = {
    "fusion": "Fusion & Special",
    "chocolate": "Chocolate",
    "step-cake": "Step Cakes",
    "themed": "Themed & Custom",
    "aari": "Aari Work",
    "blouse": "Blouse Stitching",
    "alteration": "Alteration",
    "half-saree": "Half Saree Stitching",
    "saree-threading": "Saree Knot",
    "saree-falls": "Saree Falls",
    "kids": "Kids Wear",
    "lehenga": "Lehenga",
    "art-handicraft": "Art & Handicraft",
};

// Firestore returns docs ordered by document ID, not by productCatalog.js's declaration
// order, so the sub-menu needs an explicit display order per category.
const SUBCATEGORY_ORDER = {
    tailoring: ["aari", "blouse", "alteration", "half-saree", "saree-threading", "saree-falls", "kids", "lehenga", "art-handicraft"],
};

// "All" is a computed/special view, not a real subCategory value in the data:
// cake's "All Flavors" shows one card per unique flavor, tailoring's "All
// Services" is a homepage-style tile grid linking out to the other tabs.
const AGGREGATE_ALL_LABELS = {
    cake: "All Flavors",
    tailoring: "All Services",
};

// Same sub-menu (Popular / All / subcategories) is used on both the category
// listing page and the product detail page, so it lives in one place - and
// stays visible in both, regardless of which product/tab is active.
const CategoryTabs = ({ category, activeTab, onSelect }) => {
    const { all_product } = useContext(ShopContext);
    const categoryProducts = all_product.filter((item) => item.category === category);
    // `menu` drives tab grouping when present (cakes) - falls back to
    // `subCategory` for categories that don't have a dedicated menu field
    // yet (tailoring, sweets).
    const subCategories = [...new Set(categoryProducts.map((item) => item.menu ?? item.subCategory).filter(Boolean))];
    const order = SUBCATEGORY_ORDER[category];
    if (order) {
        subCategories.sort((a, b) => order.indexOf(a) - order.indexOf(b));
    }
    // Tailoring no longer gets an in-page Popular tab - `categoryPopular` stays
    // in productCatalog.js for other categories, and `popular` (a separate flag)
    // still drives the site-wide Popular Picks section regardless of this.
    const hasPopular = category !== "tailoring" && categoryProducts.some((item) => item.categoryPopular);

    if (subCategories.length === 0 && !hasPopular) return null;

    return (
        <div className="flex flex-wrap gap-2 justify-center py-4">
            {hasPopular && (
                <button
                    className={`px-4 py-1 rounded-full border ${activeTab === "popular" ? "bg-orange-600 text-white border-orange-600" : "border-gray-300 text-gray-700"}`}
                    onClick={() => onSelect("popular")}
                >
                    Popular
                </button>
            )}
            {AGGREGATE_ALL_LABELS[category] && (
                <button
                    className={`px-4 py-1 rounded-full border ${activeTab === "all" ? "bg-orange-600 text-white border-orange-600" : "border-gray-300 text-gray-700"}`}
                    onClick={() => onSelect("all")}
                >
                    {AGGREGATE_ALL_LABELS[category]}
                </button>
            )}
            {subCategories.map((sub) => (
                <button
                    key={sub}
                    className={`px-4 py-1 rounded-full border ${activeTab === sub ? "bg-orange-600 text-white border-orange-600" : "border-gray-300 text-gray-700"}`}
                    onClick={() => onSelect(sub)}
                >
                    {SUBCATEGORY_LABELS[sub] || sub}
                </button>
            ))}
        </div>
    );
};

export default CategoryTabs;
